import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["destroyField", "newRecordField"];

  delete() {
    const parent = this.element.parentNode;

    if (this.newRecordFieldTarget.value == "true") {
      // This is a new element, we can just delete it
      parent.removeChild(this.element);
    } else {
      // This element is persisted, we need to mark it for deletion
      if (!confirm("Are you sure you want to delete this record?")) {
        return;
      }

      this.destroyFieldTarget.value = "true";
      this.element.classList.add("d-none");
    }

    const event = new CustomEvent("cortana:record_destroyed", {
      bubbles: true,
    });
    parent.dispatchEvent(event);
  }
}
